import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { TransformNS } from "../../../../../../Transform/TransformNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleMouseDownOnSelectorScaleCircleEl = (
  self,
  { event, origin_circle_el, x_axis_circle_el, y_axis_circle_el, scale_type }
) => {
  const selection_scale_transform = self._getSelectionScaleTransformThrowable();
  const selection = self._getSelectionThrowable();
  const { clientX: client_x, clientY: client_y } = event;
  const point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  const origin_point = CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)(
    origin_circle_el
  );
  if (origin_point == null) {
    return;
  }
  const { x: origin_x, y: origin_y } = origin_point;
  const x_axis_point = CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)(
    x_axis_circle_el
  );
  if (x_axis_point == null) {
    return;
  }
  const { x: x_axis_x, y: x_axis_y } = x_axis_point;
  const y_axis_point = CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)(
    y_axis_circle_el
  );
  if (y_axis_point == null) {
    return;
  }
  const { x: y_axis_x, y: y_axis_y } = y_axis_point;
  selection_scale_transform.start({
    scale_type,
    x: point.x,
    y: point.y,
    origin_x,
    origin_y,
    x_axis_x,
    x_axis_y,
    y_axis_x,
    y_axis_y,
    els: [...selection.getSelectedEls()],
  });
  self._processing_task = PROCESSING_TASK.SCALE_TRANSFORMING;
};
